import { render, staticRenderFns } from "./SwiperList.vue?vue&type=template&id=78c0e79a&scoped=true&"
import script from "./SwiperList.vue?vue&type=script&lang=js&"
export * from "./SwiperList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0e79a",
  null
  
)

export default component.exports